export const constants = {
  //* Constantes d'infos du projet, pour pied de page et modale 'ModalAbout.vue' 
  project: {
    // @install
    path: 'v7',     // vuejs files path
    database: 'v7', // database name
    layout: 'APR_js', // start layout for connection with 'Model.js'
    name: 'InFormat',
    owner: 'byCPF',
    version: '4.0',
    webName: 'www.bycpf.com',
    webLink: 'https://www.bycpf.com/',
    emailName: 'contact@bycpf.com',
    emailLink: 'mailto:contact@bycpf.com',
    copyright: '© ' + new Date().getFullYear().toString(),
  },
  server: {
    // @install
    url: 'https://cpf.in-format.com',
    domain: 'cpf.in-format.com',
    urlV7: 'https://cpf.in-format.com/v7/',
    urlOld: 'https://cpf.in-format.com',
    domainOld: 'cpf.in-format.com',
    apiTokenName: 'fm-data-api', 
    informatLogo: '/files/v7/v7/params/InFormat-CpfDigital-Vert-0880.png',
    clientLogo: '/files/v7/v7/params/logo cpf def-crop-u161.png',
  },
  //* Gestion des objets et comportements de l'interface
  interface: {
    qstFixedHeightLimit: 399,
    qstFixedHeightValue: 600,
    qstFixedHeightBool: true,
  },
  typeQuestion: {
    scq: 1, // single choice question
    mcq: 2, // multiple choices question
    open: 3,
    noQuestion: 4,
    upload: 5,
  },
  typeContent: {
    text: 1,
    video: 2,
    image: 3,
    doc: 4,
    none: 5,
    html: 6,
  },
  lessonState: {
    todo: 1, // à faire : première fois
    resume: 2, // en cours : à terminer
    done: 3, // terminée : non renouvelable
    restart: 4, // terminée : renouvelable
    wait: 5, // en attente : sequentiel
    eval: 6, // leçon d'évaluation
    evaldone: 7, // leçon d'évaluation finie
  },
  uploads: {
    filesNbr: 4, // Nombre maximum des fichiers autorisés
    filesSize: 10000000, // 10000000 = 10 Mo ; 5000000 = 5 Mo (1000 = 1 Ko)
    videosSize: 50000000, // 50000000 = 50 Mo ; 20000000 = 20 Mo
    namesLength: 35, // Longueur totale (nombre de caractèrs) du nom original des fichiers (extension incluse)
    // Visiblement Fmp a du mal avec les noms des fichiers supérierus à une 50e de caractères,
    // si on désire avoir quelque chose comme "XXX_YYMMDDhhiiss_le_nom_original_du_fichier.mov"
    // il faut limiter la longueur du nom original du fichier à 35 caractères maximum
    isNameDateHour: true, // Faut-il inclure la date et l'haure au nom des fichiers ? (YYMMDDhhiiss)
  },
  //* Type des fichiers supportés pour le système de téléversement
  // Conserver l'ordre : images, videos, offices, archives, audios, textes, dbases, all
  typeUploads: {
    images: '.ai,.psd,.eps,.bmp,.gif,.jpeg,.jpg,.png,.svg,.tif,.tiff,.webp',
    videos: '.3gp,.avi,.swf,.flv,.fla,.m4v,.mov,.mp4,.mpeg,.mpg,.qt,.webm,.wmv',
    offices: '.doc,.docx,.xls,.xlsx,.ppt,.pptx,.ods,.rtf,.pdf,.pdfs',
    archives: '.zip,.tar,.gz,.rar',
    audios: '.mp3,.aac,.aif,.aiff,.mpga,.flac,.ogg,.oga,.wav,.wma',
    textes: '.txt,.htm,.html,.php,.js,.json,.css,.xml',
    dbases: '.csv,.mdb,.fmp12,.sql,.sqlite',
    all: '.zip,.tar,.gz,.rar,.txt,.htm,.html,.php,.js,.json,.css,.xml,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.ods,.rtf,.pdf,.pdfs,.ai,.psd,.eps,.bmp,.gif,.jpeg,.jpg,.png,.svg,.tif,.tiff,.webp,.mp3,.aac,.aif,.aiff,.mpga,.flac,.ogg,.oga,.wav,.wma,.3gp,.avi,.swf,.flv,.fla,.m4v,.mov,.mp4,.mpeg,.mpg,.qt,.webm,.wmv,.csv,.mdb,.fmp12,.sql,.sqlite',
  },
  //* Les ressources images utilisées dans l'interface 
  assets: {
    load_000: 'src/assets/loader-000-48.gif',
    load_0c0: 'src/assets/loader-0c0-48.gif',
    load_fff: 'src/assets/loader-fff-48.gif',
    load_5bc: 'src/assets/loader-5bc-120.gif',
    fondVertMiniJpgFile: 'src/assets/Fond-Gen-0400.jpg',
    fondVertMediJpgFile: 'src/assets/Fond-Gen-0800.jpg',
    fondVertMaxiJpgFile: 'src/assets/Fond-Gen-1600.jpg',
    movDefaultMp4File: 'src/assets/Video-Gen-0800.mp4',
    pictoSablier: 'src/assets/Sablier.png',
    logoInformatPngFile: 'src/assets/InFormat-byCPF-FFF-000-880.png',
    logoInformatSvgFile: 'src/assets/InFormat-byCPF-FFF-000-880.svg',
    logoInformatVertPngFile: 'src/assets/InFormat-byCPF-5BC-880.png',
    logoInformatVertSvgFile: 'src/assets/InFormat-byCPF-5BC-880.svg',
    logoCpfPngFile: 'src/assets//logo_bycpf_rgb_ombr.png',
    logoCpfSvgFile: 'src/assets//logo_bycpf_rgb_ombr.svg',
    iconCheckSvgFile: 'src/assets/Icon-Check-06c.svg',
    iconCheckSvgCode: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'%3E%3Cpath d='M27.366 37.776l-8.227-4.75c-3.585-2.069-8.176-.839-10.245 2.745s-.84 8.176 2.745 10.246l14.722 8.5h0c3.585 2.069 8.176.839 10.245-2.746l18.5-32.042c2.07-3.585.84-8.176-2.745-10.246s-8.175-.839-10.245 2.746l-14.75 25.547z' fill='%2306c' /%3E%3C/svg%3E%0A",
    iconLecDicoBlack: 'src/assets/icon-Lec-Dico-000.svg',
    iconLecDicoWhite: 'src/assets/icon-Lec-Dico-FFF.svg',
    iconEmptySvgFile: 'src/assets/empty.svg',
    iconEmptySvgCode: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'/%3E%0A",
    iconFileSvgFile: 'src/assets/Icon-File-320x180.svg',
    iconFileSvgCode: "data:image/svg+xml;charset=UTF-8,%3Csvg width='320px' height='180px' viewBox='0 0 320 180' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xml:space='preserve' xmlns:serif='http://www.serif.com/' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;'%3E%3Cg transform='matrix(2.52462,0,0,2.52462,89.3182,19.3595)'%3E%3Cpath id='FileIcon_Fond' d='M36.985,0l-29.022,0c-0.808,0 -1.463,0.655 -1.463,1.926l0,53.074c0,0.345 0.655,1 1.463,1l40.074,0c0.808,0 1.463,-0.655 1.463,-1l0,-42.022c0,-0.696 -0.093,-0.92 -0.257,-1.085l-11.636,-11.636c-0.165,-0.164 -0.389,-0.257 -0.622,-0.257Z' style='fill:none;'/%3E%3Cg id='FileIcon_Bord' transform='matrix(0.396099,0,0,0.396099,-35.3789,-7.6683)'%3E%3Cpath d='M182.871,14.361c1.781,0.067 3.483,0.773 4.788,1.977c9.996,9.696 19.696,19.692 29.543,29.539c1.568,1.619 2.075,3.947 2.085,6.237l0,106.172c-0.125,4.3 -4.791,7.311 -8.472,7.45c-33.806,0.426 -67.617,0.002 -101.425,0.002c-4.194,-0.052 -8.406,-3.048 -8.654,-7.199c-0.005,-0.084 -0.005,-0.168 -0.008,-0.253l0,-134.084c0.039,-4.819 3.209,-9.638 8.471,-9.84c24.555,-0.312 49.117,-0.307 73.672,-0.001Zm-0.18,4.999l-73.269,0c-2.041,0 -3.694,1.654 -3.694,4.862l0,133.992c0,0.871 1.654,2.524 3.694,2.524l101.172,0c2.039,0 3.693,-1.653 3.693,-2.524l0,-106.09c0,-1.757 -0.235,-2.323 -0.649,-2.739l-29.376,-29.377c-0.417,-0.413 -0.982,-0.648 -1.571,-0.648Z' style='fill:%23fff;'/%3E%3C/g%3E%3Cpath id='FileIcon_Onglet' d='M37.5,0.151l0,10.349c0,0.828 0.672,1.5 1.5,1.5l10.349,0l-11.849,-11.849Z' style='fill:%23fff;'/%3E%3Cg id='FileIcon_Ombre' transform='matrix(6.12323e-17,-1,1,6.12323e-17,11.416,51.9247)'%3E%3Cpath d='M31.558,20.903c-0.265,0 -0.52,0.105 -0.707,0.293c-0.188,0.187 -0.293,0.441 -0.293,0.707c0,1.284 0,3.512 0,4.89c0,0.202 -0.122,0.384 -0.309,0.462c-0.187,0.077 -0.402,0.034 -0.545,-0.109c-2.089,-2.089 -7.43,-7.43 -9.358,-9.358c-0.391,-0.39 -0.391,-1.024 0,-1.414c1.928,-1.928 7.269,-7.269 9.358,-9.358c0.143,-0.143 0.358,-0.186 0.545,-0.109c0.187,0.078 0.309,0.26 0.309,0.462c0,1.378 0,3.606 0,4.89c0,0.266 0.105,0.52 0.293,0.707c0.187,0.188 0.442,0.293 0.707,0.293c3.195,0 9.172,0 12.367,0c0.265,0 0.519,0.106 0.707,0.293c0.187,0.188 0.293,0.442 0.293,0.707c0,1.465 0,4.179 0,5.644c0,0.265 -0.106,0.519 -0.293,0.707c-0.188,0.187 -0.442,0.293 -0.707,0.293c-3.195,0 -9.172,0 -12.367,0Z' style='fill:%23888;'/%3E%3C/g%3E%3Cg id='FileIcon_Arrow' transform='matrix(6.12323e-17,-1,1,6.12323e-17,10.416,50.9247)'%3E%3Cpath d='M31.558,20.903c-0.265,0 -0.52,0.105 -0.707,0.293c-0.188,0.187 -0.293,0.441 -0.293,0.707c0,1.284 0,3.512 0,4.89c0,0.202 -0.122,0.384 -0.309,0.462c-0.187,0.077 -0.402,0.034 -0.545,-0.109c-2.089,-2.089 -7.43,-7.43 -9.358,-9.358c-0.391,-0.39 -0.391,-1.024 0,-1.414c1.928,-1.928 7.269,-7.269 9.358,-9.358c0.143,-0.143 0.358,-0.186 0.545,-0.109c0.187,0.078 0.309,0.26 0.309,0.462c0,1.378 0,3.606 0,4.89c0,0.266 0.105,0.52 0.293,0.707c0.187,0.188 0.442,0.293 0.707,0.293c3.195,0 9.172,0 12.367,0c0.265,0 0.519,0.106 0.707,0.293c0.187,0.188 0.293,0.442 0.293,0.707c0,1.465 0,4.179 0,5.644c0,0.265 -0.106,0.519 -0.293,0.707c-0.188,0.187 -0.442,0.293 -0.707,0.293c-3.195,0 -9.172,0 -12.367,0Z' style='fill:%23A@@@A;'/%3E%3C/g%3E%3Cpath id='FileIcon_Banner' d='M48.037,56l-40.074,0c-0.808,0 -1.463,-0.655 -1.463,-1.463l0,-19.498l43,0l0,19.498c0,0.808 -0.655,1.463 -1.463,1.463Z' style='fill:%23B@@@B;'/%3E%3Cg id='FileIcon_Text' transform='matrix(1,0,0,1,-3.45233,17.7833)'%3E%3Ctext x='X@@@X' y='33.5px' style='font-family:\"Fira Code\",Tahoma,monospace;font-stretch:condensed;font-size:16px;fill:%23fff;'%3ET@@@T%3C/text%3E%3C/g%3E%3C/g%3E%3C/svg%3E",
  }
}



// WEBPACK FOOTER //
// ./src/constants.js